import React, { useEffect, useState } from 'react';
import { Link, Alert } from 'mesh-component-library';
import useAppStateData from '../../../redux/hooks/useAppStateData';

const ValidationErrorExtraHelpToast: React.FC = () => {
    const { validationErrorCounter } = useAppStateData();

    const [isActive, setIsActive] = useState(false);
    useEffect(() => {
        if (validationErrorCounter % 3 === 2) {
            setIsActive(true);
        }
    }, [validationErrorCounter]);

    return (
        <div data-testid="toast-container" className="toast-container">
            <Alert
                isActive={isActive}
                onDismiss={() => setIsActive(false)}
                variant="caution"
                dismissible={true}
                style={{ 'background-color': '#fff8e5',  'border-width': '0px 0px 0px 0.25rem', 'font-family': '"Allstate Sans-Medium", sans-serif', 'margin-bottom': '1rem'}}
            >
                <div style={{'padding':'0 10px'}}>
                    <div className="toast-header">It seems you&apos;re having trouble</div>
                    <div className="toast-body">
                        If you&apos;re unable to proceed, please reach out to your Claim Contact in
                        <Link
                            href="https://www.allstate.com/claims/track-claim.aspx"
                            style={{color:'#013aa9'} }
                        >
                            MyClaim
                        </Link>
                    </div>
                </div>
            </Alert>
        </div>
    );
};

export default ValidationErrorExtraHelpToast;
